import { NewMinerI } from "@services/addNewMiner";
import { ALGOS_E } from "@constants/Algos";
import {
  MTSort,
  SortDirection,
} from "@services/getMinerList";
import { MinerHashEvent } from "@services/http/socket/responses";
import { FormValues } from "@utils/getFormValue";
import { IAdminMinerInfo, IAdminMinerTable } from "@services/getMinerInfo";

export enum ActionTypesMinersTable {
  CLEAN_STATE = "MINERS_TABLE_CLEAN_STATE",
  SET_PAGE = "MINERS_TABLE_SET_PAGE",
  SET_STATE = "MINERS_TABLE_SET_STATE",
  SET_SORT = "MINERS_TABLE_SET_SORT",
  TEMP_SAVE_PAGE_SIZE = "MINERS_TABLE_TEMP_SAVE_PAGE_SIZE",
  SET_ADMIN_ONLY_SUMMARY_CHART_FLAG = "MINERS_TABLE_ADMIN_ONLY_FLAG",
}

export interface ActionBaseMinersTable {
  type: ActionTypesMinersTable;
  payload?: any;
}

export interface ActionSetPage extends ActionBaseMinersTable {
  payload: {
    Page: number;
    PageSize: number;
  };
}

export interface ActionSetState extends ActionBaseMinersTable {
  payload: {
    Page: number;
    PageSize: number;
  };
}

export interface ActionSetSort extends ActionBaseMinersTable {
  payload: {
    sort: [MTSort, SortDirection];
  };
}

export interface ActionTempSavePageSize extends ActionBaseMinersTable {
  payload: number;
}

export interface ActionSetMiners extends ActionBaseMinersTable {
  payload: {
    Miners: IAdminMinerTable[];
    Total?: number;
  };
}

export interface ActionUpdateMiner extends ActionBaseMinersTable {
  payload: {
    Miner: IAdminMinerTable;
  };
}

export interface ActionUpdateMinerCurrentSpeed extends ActionBaseMinersTable {
  payload: {
    minerId: string;
    speed: number;
  };
}

export interface ActionTempSaveSelectedPool extends ActionBaseMinersTable {
  payload: string | ALGOS_E;
}

export interface ActionCleanTableState extends ActionBaseMinersTable { }

export interface ActionAppendChartValue extends ActionBaseMinersTable {
  payload: {
    minerId: string;
    value: number;
    time: number;
  };
}

export interface ActionAddNewMiner extends ActionBaseMinersTable {
  payload: NewMinerI;
}

export interface ActionAddNewMinerList extends ActionBaseMinersTable {
  payload: NewMinerI[];
}
export interface ActionDeleteMiner extends ActionBaseMinersTable {
  payload: string;
}

export interface IChangeMinerSettingPayload<T = any> {
  id: string;
  data: T;
}
export interface ActionChangeMinerSettings extends ActionBaseMinersTable {
  payload: IChangeMinerSettingPayload;
}

export interface ActionChangeMinerSpeed extends ActionBaseMinersTable {
  payload: IChangeMinerSettingPayload<MinerHashEvent>;
}

export interface ActionChangeMinerSmooth extends ActionBaseMinersTable {
  payload: IChangeMinerSettingPayload<boolean>;
}

export interface ActionSetAdminOnlyFlag extends ActionBaseMinersTable {
  payload: boolean;
}

export interface ActionSetMinerInfo extends ActionBaseMinersTable {
  payload: {
    info: IAdminMinerInfo;
    isAdmin: boolean;
  };
}
